
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var tabs = document.querySelectorAll(".js-about-tab");
    if (!tabs.length) return;

    var panels = document.querySelectorAll(".about__tab-panel");

    function activateTab(targetTab) {
      var targetName = targetTab.getAttribute("data-tab-target");
      if (!targetName) return;

      
      tabs.forEach(function (tab) {
        var isTarget = tab === targetTab;
        tab.classList.toggle("is-active", isTarget);
        tab.setAttribute("aria-selected", isTarget ? "true" : "false");
        tab.setAttribute("tabindex", isTarget ? "0" : "-1");
      });

      
      panels.forEach(function (panel) {
        var panelId = panel.getAttribute("id") || "";
        var isTarget = panelId === "about-panel-" + targetName;
        panel.classList.toggle("is-active", isTarget);
        if (isTarget) {
          panel.removeAttribute("hidden");
        } else {
          panel.setAttribute("hidden", "");
        }
      });
    }

    tabs.forEach(function (tab, index) {
      
      tab.addEventListener("click", function (event) {
        event.preventDefault();
        activateTab(tab);
      });

      
      tab.addEventListener("keydown", function (event) {
        var key = event.key;
        var nextIndex = null;

        if (key === "ArrowRight" || key === "Right") {
          nextIndex = (index + 1) % tabs.length;
        } else if (key === "ArrowLeft" || key === "Left") {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (key === "Home") {
          nextIndex = 0;
        } else if (key === "End") {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex !== null) {
          event.preventDefault();
          var nextTab = tabs[nextIndex];
          activateTab(nextTab);
          nextTab.focus();
        }
      });
    });
  });
})();
